import { jsx as a, jsxs as i, Fragment as c } from "react/jsx-runtime";
import { Frame as m } from "../Frame/Frame.js";
import { Spinner as g } from "../Spinner/Spinner.js";
import { cva as p } from "../apps/ui/styled-system/css/cva.js";
import { cx as f } from "../apps/ui/styled-system/css/cx.js";
import { css as e } from "../apps/ui/styled-system/css/css.js";
function R({
  children: b,
  className: s,
  disabled: n,
  icon: u,
  loading: r,
  shape: _ = "normal",
  size: o,
  variant: v = "secondary",
  width: t = "auto",
  type: h = "button",
  ...l
}) {
  const d = m.useFrame(!0);
  return o ?? (o = { dialog: "medium", full: "large" }), r === !0 && (r = "Loading…"), /* @__PURE__ */ a(
    "button",
    {
      className: f(
        e({
          _active: {
            transform: "translateY(1px)"
          },
          _dark: {
            "&:hover:not(:disabled)": {
              backgroundColor: "hsl(from var(--button-bg) h s calc(l + 2))",
              borderColor: "hsl(from var(--button-bd) h s calc(l + 2))"
            }
          },
          _disabled: {
            pointerEvents: "none"
          },
          _focusVisible: {
            outline: "2px solid var(--color-th_focus)",
            outlineOffset: 2
          },
          "&:hover:not(:disabled)": {
            backgroundColor: "hsl(from var(--button-bg) h s calc(l - 2))",
            borderColor: "hsl(from var(--button-bd) h s calc(l - 2))"
          },
          alignItems: "center",
          backgroundColor: "var(--button-bg)",
          border: "1px solid transparent",
          borderColor: "var(--button-bd)",
          borderRadius: "var(--radius-th_medium)",
          cursor: "pointer!",
          display: "inline-flex",
          flex: "0 0 auto",
          justifyContent: "center",
          touchAction: "none",
          whiteSpace: "nowrap"
        }),
        t === "full" && e({ width: "100%" }),
        t === "grow" && e({ flexGrow: 1 }),
        p({
          variants: {
            colors: {
              // disabled is a color variant rather than being applied when
              // the button is disabled, this is because in certain cases we
              // want the button to be disabled, but not to look like our
              // default disabled state, e.g. when the button is loading.
              disabled: {
                "--button-bd": "var(--border-color-th_disabled)",
                "--button-bg": "var(--background-color-th_disabled)",
                color: "var(--text-color-th_disabled)"
              },
              negative: {
                "--button-bd": "var(--border-color-th_negative)",
                "--button-bg": "var(--background-color-th_negative)",
                color: "var(--text-color-th_negative)"
              },
              "negative-secondary": {
                "--button-bd": "var(--border-color-th_negative-secondary)",
                "--button-bg": "var(--background-color-th_negative-secondary)",
                color: "var(--text-color-th_negative-secondary)"
              },
              positive: {
                "--button-bd": "var(--border-color-th_positive)",
                "--button-bg": "var(--background-color-th_positive)",
                color: "var(--text-color-th_positive)"
              },
              primary: {
                "--button-bd": "var(--border-color-th_primary)",
                "--button-bg": "var(--background-color-th_primary)",
                color: "var(--text-color-th_primary)"
              },
              secondary: {
                "--button-bd": "var(--border-color-th_secondary)",
                "--button-bg": "var(--background-color-th_secondary)",
                color: "var(--text-color-th_secondary)"
              },
              strong: {
                "--button-bd": "var(--border-color-th_strong)",
                "--button-bg": "var(--background-color-th_strong)",
                color: "var(--text-color-th_strong)"
              }
            },
            size: {
              large: {
                borderRadius: 21,
                fontSize: 16,
                // large button temporarily made smaller, until we move
                // to layouts adapted to larger (52px tall) buttons.
                // height: 52,
                // borderRadius: 26,
                height: 42,
                paddingInline: 20
              },
              medium: {
                borderRadius: 8,
                fontSize: 15,
                height: 38,
                paddingInline: 16
              },
              small: {
                borderRadius: 6,
                fontSize: 13,
                height: 28,
                paddingInline: 8
              }
            }
          }
        })({
          colors: n ? "disabled" : v,
          size: typeof o == "string" ? o : d && o[d.mode] || "medium"
        }),
        s
      ),
      disabled: !!r || n,
      type: h,
      ...l,
      style: {
        ...l.style,
        width: typeof t == "number" ? t : void 0
      },
      children: /* @__PURE__ */ a(
        "div",
        {
          className: e({
            alignItems: "center",
            display: "flex",
            gap: o === "small" ? 6 : 8,
            height: "100%"
          }),
          children: r ? /* @__PURE__ */ i(c, { children: [
            /* @__PURE__ */ a(g, { size: o === "small" ? "small" : "medium" }),
            r
          ] }) : /* @__PURE__ */ i(c, { children: [
            u,
            b
          ] })
        }
      )
    }
  );
}
export {
  R as Button
};
//# sourceMappingURL=Button.js.map
